export default "__VITE_ASSET__Dvzzf4F6__"